import { getPlanForProductSku } from "./planToProduct";
import { BillingType } from "../constants/plan";
import Plan from "../store/plan/model";

export function productPromotionPrice(sku: string) {
  const plan: Plan = getPlanForProductSku(sku, BillingType.OneTime);
  const priceLocale = plan?.amount || 0;

  return (priceLocale / 100).toFixed(2);
}
